import { render, staticRenderFns } from "./AddBannerComponent.vue?vue&type=template&id=f7ae34b4&scoped=true"
import script from "./AddBannerComponent.vue?vue&type=script&lang=js"
export * from "./AddBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ae34b4",
  null
  
)

export default component.exports